
<template>
    <div class="memorandum_info">
        <div class="tender_data">
            <legend>
                Протокол засідання тендерної комісії <br>
                з проведення процедури розгляду тендерних пропозицій № {{tender_number_field.counterparty}}
            </legend>
            
            <div class="before_change">
                <table class="table" style="border-collapse: collapse;" v-if="draw_items.length > 0">
                    <thead>
                        <tr>
                            <th :colspan="head_items.length" class="bold">
                                ПРОПОЗИЦІЇ*
                            </th>
                        </tr>
                        <tr>
                            <th class="field_head" v-for="head in head_items">
                                {{head.name}}
                            </th>
                        </tr>
                    </thead>
                    
                    <tbody>
                       <tender_field
                           @click_item="show_info"
                           :key="'drw_' + field.id" :field="field" v-for="field in draw_items"></tender_field>
                    </tbody>
                </table>
                <div class="prim"> *Детальна пропозиція - у додатках</div>
                
                
                <legend class="mt-5">Переможець тендеру</legend>
                <div class="fields_insert row-fluid" v-if="winner_items.length > 0">
                    <div v-for="winner in winner_items">
                        <b-row class="mem_text position-relative">
                            
                            <b-col sm="3" class="position-relative" >
                                <div class="cursor-pointer fs-xl text-center" v-on:click="show_info(winner)">
                                    {{winner.org_name}}
                                </div>
                            </b-col>
                            
                            <b-col sm="9" class="position-relative" >
                                <div class="text_winner">
                                    <mem_text
                                        :show_label="false"
                                        @edit_text="edit_winner(winner)"
                                        key="winner"
                                        label="Переможець тендеру"
                                        :text="winner.payment">
                                    </mem_text>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
            
            <company_info></company_info>
        </div>
    </div>
</template>

<script>
import Tender_field from "./tender_field.vue";
import company_info from "../../../../../counterparty/company_info.vue";
import Mem_text from "../../sides/helpers/mem_text.vue";
import {win} from "../../../../../../../../../media/vendor/tinymce/tinymce";

export default {
    name: "mem_inside_tender",
    components: {Mem_text, Tender_field,company_info},
    props : {
        "addon_data" : {
            type : Object
        },
        
        'mem' : {
            type : Object
        },
    },
    
    created() {
        EventBus.$on('finish_edit',this.edit_finish);
    },
    
    methods : {
        
        edit_finish(event) {
            try {
                const [parsedType, winner_id] = event.uniq.split('|');
                if(parsedType === 'winner') {
                    api.patch('/memorandums/' + this.mem.id + '/tender/winner/' + winner_id, {
                        "field_type" : parsedType,
                        "field_val" : event.text,
                    }).then(({data}) => {
                        if (data.status === 'operation_success') {
                            EventBus.$emit("reload_mem", {"mem_id": this.mem.id});
                        }
                    }).catch(err => {
                        EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                    });
                }
            }
            catch (e) {
            
            }
        },
        
        edit_winner(winner) {
            console.log(winner)
            
            this.get_rights().then(({data}) => {
                IMC_CORE.hideloading();
                if(data.status === 'operation_success') {
                    EventBus.$emit('load_editor',{
                        'message'   : winner.payment,
                        'uniq'      : 'winner' + '|' + winner.id,
                    });
                }
            }).catch(err => {
                IMC_CORE.hideloading();
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        get_rights() {
            return api.get('/memorandums/' + this.mem.id + '/rights')
        },
        
        show_info(field) {
            console.log(field);
            EventBus.$emit('show_edrpou_info',field.edrpou)
        },
    },
    
    computed : {
        
        tender_number_field() {
            let field = {
                'counterparty' : "",
            };
            
            try {
                this.addon_items.map(item => {
                    if (item.field_type === 'tender_number') {
                        field = item;
                    }
                });
            }
            catch (e) {
            
            }
            return field;
        },
        
        addon_items() {
            if(this.addon_data.hasOwnProperty('items')) {
                return this.addon_data.items;
            }
            
            return [];
        },
        
        head_items() {
            if(this.addon_data.hasOwnProperty('head_items')) {
                return this.addon_data.head_items;
            }
            
            return [];
        },
        
        draw_items() {
            return this.addon_items.filter(item => {
                return item.field_type === 'tab';
            });
        },
        
        winner_items() {
            return this.addon_items.filter(item => {
                return item.field_type === 'winner';
            });
        },
        
    },
    
}
</script>



<style scoped>

</style>